<template>
    <div v-if="question" class="q-wrap">
        <div class="q-input">
            <kimsa-rpe-slider :value="answer" :min="question.min" :max="question.max" :label="`${answer}`"
                @change="answer = $event" />
            <kimsa-text-field v-if="question.comment" class="mt-6" @change="comment = $event" :value="comment"
                :placeholder="$t('common.load_comment')" force-value dense no-elevation />
        </div>
        <div class="q-actions">
            <v-btn block large depressed color="primary" class="black--text q-next" :disabled="answer === null"
                @click="sendAnswer">
                {{ $t('common.next') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import KimsaRpeSlider from '../../common/inputs/KimsaRpeSlider.vue';
import KimsaTextField from '../../common/inputs/KimsaTextField.vue'
export default {
    components: { KimsaTextField, KimsaRpeSlider },
    props: {
        question: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            answer: Math.round((this.question.min + this.question.max) / 2),
            comment: '',
        }
    },
    methods: {
        sendAnswer() {
            const vm = this;
            vm.$emit('click:next', vm.question, { value: vm.answer, comment: vm.comment })
        },
    },
}
</script>

<style scoped>
.q-wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
    padding-top: 20px;
}

.q-input {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 480px;
    width: 100%;
    margin: 0 auto;
}

.q-actions {
    max-width: 480px;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 8px;
}

.q-next {
    border-radius: 12px;
    font-weight: 700;
    text-transform: none;
    letter-spacing: 0;
}
</style>
